import Reply from "./Reply";
export default Reply;
